import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import imgLogoIcon from "../../assets/logo/logo-icon.png";
import imgBox1 from "../../assets/images/portrait-beautiful 2.png";
import imgBox2 from "../../assets/images/portrait-beautiful 1.png";
import imgBox3 from "../../assets/images/xAO7so 1.png";
import imgBox4 from "../../assets/images/MlDLcs 1.png";
import aboutUs from "../../assets/images/Rectangle 30.png";
import logoBanner from "../../assets/logo/Logo-BlueZone.png";
import check from "../../assets/icons/mdi_check.svg";
import fast from "../../assets/icons/fast-ic.svg";
import fastClock from "../../assets/icons/fast-ic-clock.svg";
import group from "../../assets/icons/Group.svg";
import handTouch from "../../assets/icons/hand-touch-ic.svg";
import calendar from "../../assets/icons/calendar-ic.svg";
import moneyOnline from "../../assets/icons/Money-Online.svg";
import creditCard from "../../assets/icons/fa_credit-card.svg";
import listCheck from "../../assets/icons/ant-design_file-protect-outlined.svg";
import smile from "../../assets/icons/Smile.svg";
import listForm from "../../assets/icons/form-icon.svg";
import telesale from "../../assets/icons/Telesale-icon.svg";
import finishForm from "../../assets/icons/finish-form-icon.svg";
import App from "../../assets/icons/APp-icon.svg";
import elipsePurple from "../../assets/icons/ellipse-purple.svg";
import elipseGreen from "../../assets/icons/ellipse-green.svg";
import elipsePink from "../../assets/icons/ellipse-pink.svg";
import elipseBlue from "../../assets/icons/ellipse-blue.svg";
import creative from "../../assets/icons/creative.svg";
import accuracy from "../../assets/icons/accuracy.svg";
import kind from "../../assets/icons/person.svg";
import easy from "../../assets/icons/like.svg";
import polygon1 from "../../assets/polygons/Polygon 1 (Stroke).svg";
import polygon2 from "../../assets/polygons/Polygon 2 (Stroke).svg";
import polygon3 from "../../assets/polygons/Polygon 3 (Stroke).svg";
import polygon4 from "../../assets/polygons/Polygon 4 (Stroke).svg";
import polygon5 from "../../assets/polygons/Polygon 5 (Stroke).svg";
import polygon6 from "../../assets/polygons/Polygon 6 (Stroke).svg";
import polygon7 from "../../assets/polygons/Polygon 7 (Stroke).svg";
import polygon8 from "../../assets/polygons/Polygon 8 (Stroke).svg";
import vinaphone from "../../assets/logo-partner/vinaphone.png";
import trueMoney from "../../assets/logo-partner/true-money.png";
import feCredit from "../../assets/logo-partner/fe-credit.png";
import vib from "../../assets/logo-partner/vib-blue.png";
import lotte from "../../assets/logo-partner/lotte.png";
import tpbank from "../../assets/logo-partner/tpbank.png";
import bidv from "../../assets/logo-partner/bidv.png";
import f88 from "../../assets/logo-partner/f88.jpg";
import mobifone from "../../assets/logo-partner/mobifone.png";
import techcombank from "../../assets/logo-partner/techcombank.png";
import tpfico from "../../assets/logo-partner/tpfico.png";
import viettel from "../../assets/logo-partner/viettel.png";
import { Link } from "react-router-dom";

const HomePage = () => {
  return (
    <div className="home-page">
      <section className="hero-section">
        <div className="hero-content-home container">
          <div className="row">
            <div className="col-lg-6 mt-4">
              <div className="content-right">
                <div className="hero-subtitle">Giải pháp tài chính ưu việt</div>
                <h1 className="hero-title">
                  <span className="text-green">Vay tiền - Mở thẻ</span> tín dụng
                  online nhanh chóng
                </h1>
                <div className="hero-features">
                  <div className="hero-feature-item d-flex align-items-center">
                    <div className="check-icon">
                      <img src={check} alt="check" className="check" />
                    </div>
                    <div className="text-banner-home">
                      <strong>Vay tiền mặt: </strong>
                      Vay online chuyển khoản ngay 10 triệu - 100 triệu, lãi
                      suất ưu đãi, <strong>KHÔNG</strong> phí.
                    </div>
                  </div>
                  <div className="hero-feature-item d-flex align-items-center">
                    <div className="check-icon">
                      <img src={check} alt="check" className="check" />
                    </div>
                    <div className="text-banner-home">
                      <strong>Mở thẻ tín dụng: </strong>
                      Thủ tục online đơn giản, Hạn mức khủng, hoàn tiền không
                      giới hạn, trả góp lãi suất 0%
                    </div>
                  </div>
                </div>
              </div>
              <div className="button-group">
                <Link to={"/dich-vu/vay-online"} className="btn-link">
                  <button className="button primary">Vay tiền online</button>
                </Link>
                <Link to={"/dich-vu/mo-the"} className="btn-link">
                  <button className="button secondary">
                    mở thẻ tín dụng online
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section">
        <div className="container">
          <div className="features-grid d-flex justify-content-center row mx-0">
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={fast} alt="Feature 1" />
                </div>
                <div className="feature-text">
                  Hạn mức tối đa lên đến
                  <br /> 100 triệu đồng
                </div>
                <div className="feature-description">
                  Đáp ứng mọi nhu cầu tài chính của bạn
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={fastClock} alt="Feature 2" />
                </div>
                <div className="feature-text">
                  Thao tác đăng kí
                  <br />
                  đơn giản
                </div>
                <div className="feature-description">
                  Dễ dàng, nhanh chóng chỉ trong vài phút
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={group} alt="Feature 3" />
                </div>
                <div className="feature-text">
                  Lãi suất ưu đãi
                  <br />
                  12-20%/năm
                </div>
                <div className="feature-description">
                  Tiết kiệm chi phí tối đa cho khách hàng
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={handTouch} alt="Feature 4" />
                </div>
                <div className="feature-text">
                  Duyệt vay siêu tốc
                  <br />
                  Kết quả Online 100%
                </div>
                <div className="feature-description">
                  Nhận kết quả nhanh chóng, thuận tiện 24/7
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-2">
              <div className="feature-item">
                <div className="feature-icon">
                  <img src={calendar} alt="Feature 5" />
                </div>
                <div className="feature-text">
                  Kì hạn vay
                  <br />
                  linh hoạt
                </div>
                <div className="feature-description">
                  Tối đa lên đến 36 tháng
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <img className="about-image" src={aboutUs} alt="About Blue-zone" />
        <div className="about-content">
          <h2 className="about-title">Về chúng tôi</h2>
          <div className="about-subtitle mb-2">
            Trao cho bạn một tương lai tài chính vững vàng, ngay KHI BẠN CẦN
          </div>
          <p className="about-description">
            Blue-zone ra đời vào năm 2025 với vai trò là một website cung cấp
            thông tin về các sản phẩm tài chính đầy đủ và cập nhật nhất đến cho
            Khách hàng từ các Ngân hàng và Tổ chức tài chính uy tín tại Việt
            Nam.
            <br />
            <br />
            Blue-zone thực hiện lựa chọn và giới thiệu các sản phẩm tài chính
            phù hợp dựa trên các thông tin được Khách hàng cung cấp,{" "}
            <strong>
              đảm bảo tỷ lệ phê duyệt cao với thủ tục đơn giản, đi kèm nhiều ưu
              đãi độc quyền
            </strong>{" "}
            trên nền tảng công nghệ tiên tiến và thân thiện với người dùng.
          </p>
        </div>
      </section>

      <section className="about-stats">
        <div className="container">
          <div className="stats-container row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 d-flex justify-content-center">
            <div className="stats-item">
              <img src={moneyOnline} alt="Khách hàng" className="stats-icon" />
              <div className="stats-number">+10.000</div>
              <div className="stats-label">Khách hàng tin tưởng</div>
            </div>
            <div className="stats-item">
              <img src={creditCard} alt="Đối tác" className="stats-icon" />
              <div className="stats-number">+3.500</div>
              <div className="stats-label">Đối tác tài chính</div>
            </div>
            <div className="stats-item">
              <img src={listCheck} alt="Sản phẩm" className="stats-icon" />
              <div className="stats-number">+1.000</div>
              <div className="stats-label">Sản phẩm tài chính</div>
            </div>
            <div className="stats-item">
              <img src={smile} alt="Kinh nghiệm" className="stats-icon" />
              <div className="stats-number">+10.500</div>
              <div className="stats-label">Năm kinh nghiệm</div>
            </div>
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="container text-center">
          <h2 className="services-title">Blue-zone - Khi Bạn Cần</h2>
          <p className="services-description">
            Hiện nay, ngoài các sản phẩm Vay tiêu dùng và Mở thẻ tín dụng phê
            duyệt liền tay Blue-zone còn mở rộng thêm liên kết thêm mạng lưới
            sản phẩm về các dịch vụ bảo hiểm nhân thọ từ Ngân hàng và Công ty
            Tài chính hàng đầu.
          </p>
          <div className="services-slider">
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              navigation
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              breakpoints={{
                375: {
                  slidesPerView: 1,
                },
                390: {
                  slidesPerView: 1,
                },
                992: {
                  slidesPerView: 2,
                },
              }}
              // nextButton={<div className="swiper-button-next" />}
              // prevButton={<div className="swiper-button-prev" />}
            >
              <SwiperSlide>
                <div className="service-card">
                  <div className="card-front">
                    <h3 className="card-title">VAY TIỀN ONLINE</h3>
                    <div className="card-subtitle">
                      Tiền mặt liền tay, thỏa ngay mong đợi
                    </div>
                    <div className="divider" />
                    <div className="image-stack">
                      <img
                        src={imgLogoIcon}
                        alt="Vay tiền online"
                        className="img-background"
                      />
                      <img
                        src={imgBox1}
                        alt="Vay tiền online"
                        className="img-foreground"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="service-card">
                  <div className="card-front">
                    <h3 className="card-title">THẺ TÍN DỤNG</h3>
                    <div className="card-subtitle">
                      Mở thẻ siêu nhanh, giao dịch thả phanh
                    </div>
                    <div className="divider" />
                    <div className="image-stack">
                      <img
                        src={imgLogoIcon}
                        alt="Vay tiền online"
                        className="img-background"
                      />
                      <img
                        src={imgBox2}
                        alt="Vay tiền online"
                        className="img-foreground"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="service-card">
                  <div className="card-front">
                    <h3 className="card-title">BẤT ĐỘNG SẢN</h3>
                    <div className="card-subtitle">
                      Nền tảng bất động sản uy tín
                    </div>
                    <div className="divider" />
                    <div className="image-stack">
                      <img
                        src={imgLogoIcon}
                        alt="Vay tiền online"
                        className="img-background"
                      />
                      <img
                        src={imgBox3}
                        alt="Vay tiền online"
                        className="img-foreground"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="service-card">
                  <div className="card-front">
                    <h3 className="card-title">BẢO HIỂM</h3>
                    <div className="card-subtitle">Sống trọn an tâm</div>
                    <div className="divider" />
                    <div className="image-stack">
                      <img
                        src={imgLogoIcon}
                        alt="Vay tiền online"
                        className="img-background"
                      />
                      <img
                        src={imgBox4}
                        alt="Vay tiền online"
                        className="img-foreground"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      <section className="works-section">
        <h2 className="works-title">Blue-zone hoạt động như thế nào?</h2>
        <p className="works-description">
          Với tiêu chí phục vụ Khách hàng nhanh chóng và hiệu quả, Blue-zone ứng
          dụng công nghệ tiên tiến cùng trải nghiệm được thiết kế thân thiện
          giúp việc thao tác trở nên đơn giản, kết quả phê duyệt nhận ngay tức
          thì, không cần phải chờ đợi lâu.
        </p>
        <div className="works-content">
          <div className="work-one">
            <img src={listForm} alt="listForm" className="listForm" />
            <img src={polygon1} alt="polygon1" className="polygon-1" />
            <div className="line-1"></div>
            <div className="elipse-purple">
              <img src={elipsePurple} alt="" />
            </div>
            <span className="number-one">1</span>
            <span className="text-work-one">
              Điền thông tin
              <br /> đăng ký vay
            </span>
          </div>

          <div className="work-two">
            <img src={telesale} alt="telesale" className="telesale" />
            <img src={polygon2} alt="polygon2" className="polygon-2" />
            <div className="line-2"></div>
            <div className="elipse-green">
              <img src={elipseGreen} alt="" />
            </div>
            <span className="number-two">2</span>
            <span className="text-work-two">
              Nhân viên chăm sóc khách hàng sẽ liên lạc với bạn để tư vấn &
              hướng dẫn chuẩn bị các thủ tục đơn giản, nhanh gọn
            </span>
          </div>

          <div className="work-three">
            <img src={finishForm} alt="finishForm" className="finishForm" />
            <img src={polygon3} alt="polygon3" className="polygon-3" />
            <div className="line-3"></div>
            <div className="elipse-pink">
              <img src={elipsePink} alt="" />
            </div>
            <span className="number-three">3</span>
            <span className="text-work-three">
              Bạn nhận luôn kết quả phê duyệt hoặc cập nhật thông qua Zalo OA
              hoặc website của Blue-zone để hoàn tất thủ tục & ký hồ sơ chỉ
              trong vòng 15 phút
            </span>
          </div>

          <div className="work-four">
            <img src={App} alt="APp" className="app" />
            <img src={polygon4} alt="polygon4" className="polygon-4" />
            <div className="line-4"></div>
            <div className="elipse-blue">
              <img src={elipseBlue} alt="" />
            </div>
            <span className="number-four">4</span>
            <span className="text-work-four">
              <ul>
                <li>Nhận tiền giải ngân thông qua phương thức đã đăng ký</li>
                <li>Nhận thẻ tín dụng tới địa chỉ mong muốn</li>
              </ul>
            </span>
          </div>

          <img src={polygon5} alt="polygon5" className="polygon-5" />
          <img src={polygon6} alt="polygon6" className="polygon-6" />
          <img src={polygon7} alt="polygon7" className="polygon-7" />
          <img src={polygon8} alt="polygon8" className="polygon-8" />
          <div className="line"></div>
        </div>
      </section>

      <section className="banner-home-section">
        <div className="banner-home-content">
          <div className="banner-home-logo">
            <img src={logoBanner} alt="banner-logo" />
          </div>
          <h1 className="banner-home-title">
            Đăng ký ngay sản phẩm tài chính phù hợp với nhu cầu của bạn
          </h1>
          <div className="banner-home-description">
            <span>
              Hãy để lại thông tin của mình chính xác đúng và đủ theo yêu cầu,
              nhân viên tư vấn Blue ngay lập tức sẽ liên hệ và kết nối bạn đến
              với sản phẩm tài chính phù hợp nhất
            </span>
          </div>
          <div className="button-banner-home">
            <a href="/lien-he" className="btn-link">
              <button className="button-ban green">
                Liên hệ với chúng tôi
              </button>
            </a>
          </div>
        </div>
      </section>

      <section className="partners-section">
        <h2 className="partners-title">Đồng hành các đối tác uy tín</h2>
        <p className="partners-description">
          Bluezone là đối tác chiến lược của nhiều Ngân hàng và Tổ chức tài
          chính lớn, uy tín khắp Việt Nam
        </p>
        <div className="partners-slider">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={40}
            slidesPerView={4}
            navigation
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            breakpoints={{
              375: {
                slidesPerView: 1,
              },
              425: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 4,
              },
            }}
            // nextButton={<div className="swiper-button-next" />}
            // prevButton={<div className="swiper-button-prev" />}
          >
            <SwiperSlide>
              <div className="image-logo">
                <img src={vinaphone} alt="vinaphone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={trueMoney} alt="trueMoney" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={feCredit} alt="vinaphone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={lotte} alt="lotte" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img
                  src={techcombank}
                  alt="techcombank"
                  className="logo-partner"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={tpbank} alt="tpbank" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={vib} alt="vib" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={bidv} alt="bidv" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={f88} alt="f88" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={mobifone} alt="mobifone" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={tpfico} alt="tpfico" className="logo-partner" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image-logo">
                <img src={viettel} alt="viettel" className="logo-partner" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>

      <section className="why-chooses-section">
        <h2 className="why-chooses-title">Tại sao bạn nên chọn Blue-zone?</h2>
        <div className="container">
          <div className="why-chooses-grid mx-0 gap-4 mb-4">
            {/* <div className="col-12 col-md-4 col-lg-2"> */}
            <div className="why-choose-item">
              <div className="why-choose-icon">
                <img src={creative} alt="Why choose 1" className="creative" />
              </div>
              <div className="why-choose-text">Creative</div>
              <div className="why-choose-description">
                Ứng dụng nền tảng công nghệ và trí tuệ nhân tạo để xây dựng các
                sản phẩm tài chính số sáng tạo, đột phá và khác biệt trên thị
                trường.
              </div>
            </div>
            {/* </div> */}

            {/* <div className="col-12 col-md-4 col-lg-2"> */}
            <div className="why-choose-item">
              <div className="why-choose-icon">
                <img src={accuracy} alt="Why choose 2" className="accuracy" />
              </div>
              <div className="why-choose-text">Accuracy</div>
              <div className="why-choose-description">
                Mọi quy trình và sản phẩm được hoàn thiện với độ chính xác tối
                đa, mang đến cho bạn những trải nghiệm tài chính an toàn nhất.
              </div>
            </div>
            {/* </div> */}

            {/* <div className="col-12 col-md-4 col-lg-2"> */}
            <div className="why-choose-item">
              <div className="why-choose-icon">
                <img src={kind} alt="Why choose 3" className="kind" />
              </div>
              <div className="why-choose-text">Kind</div>
              <div className="why-choose-description">
                Blue-zone đồng hành cùng bạn trên mọi hành trình chinh phục tài
                chính số, luôn lắng nghe và hỗ trợ bạn một cách nhanh chóng, kịp
                thời.
              </div>
            </div>
            {/* </div> */}

            {/* <div className="col-12 col-md-4 col-lg-2"> */}
            <div className="why-choose-item">
              <div className="why-choose-icon">
                <img src={easy} alt="Why choose 4" className="easy" />
              </div>
              <div className="why-choose-text">Easy</div>
              <div className="why-choose-description">
                Mang đến trải nghiệm tuyệt vời, giúp bạn tận hưởng cuộc sống
                thật dễ dàng, nhanh, tiện và liền mạch.
              </div>
            </div>
            {/* </div> */}
          </div>

          <div className="d-flex justify-content-center">
            <a href="/dich-vu/vay-online" className="btn-link">
              <button className="btn-register mt-2">Đăng ký ngay</button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
